import { render } from "./project-board-list.vue?vue&type=template&id=7297d75a&scoped=true"
import script from "./project-board-list.vue?vue&type=script&lang=js"
export * from "./project-board-list.vue?vue&type=script&lang=js"

import "./project-board-list.vue?vue&type=style&index=0&id=7297d75a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7297d75a"]])

export default __exports__